module.exports = __webpack_public_path__ + "static/media/10_eriarvoisuuden-vahentaminen_en_US.4d01fc2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/10_eriarvoisuuden-vahentaminen_en_US.svg
// module id = ./src/images/agendaIcons/10_eriarvoisuuden-vahentaminen_en_US.svg
// module chunks = 1